/* eslint-disable */

var httpinvoke = require('httpinvoke/httpinvoke-browser.js');
var _defaults = require('lodash.defaults');



function checkStatusCode(res) {
  if (res.statusCode >= 300) {
    throw new Error('Server responded with status code ' + res.statusCode);
  }
}

var request = function(method, url, data, params) {
  var requestParams = {
    converters: {
      'text json': JSON.parse,
      'json text': JSON.stringify
    }
  };
  var encoded = $.param(data);
  if (encoded) {
    requestParams.input = encoded;
  }

  requestParams = _defaults(params, requestParams);
  return httpinvoke(url, method, requestParams).then(function(resp) {
    checkStatusCode(resp);
    return resp;
  });
};

var get = function(url, data, params) {
  return request('GET', url, data, params);
};

var post = function(url, data, params) {
  if (!params) {
    params = {};
  }
  params.headers = {'Content-Type': 'application/x-www-form-urlencoded'};
  return request('POST', url, data, params);
};


module.exports = {
  get: get,
  post: post
};
